import { docs } from '../content';

const docLinks = [
  ['/docs', 'Overview'],
  ['/docs/quickstart', 'Quickstart'],
  ['/docs/developer-setup', 'Developer Setup'],
  ['/docs/downloads', 'Downloads'],
  ['/docs/analyzer', 'Web Analyzer'],
  ['/docs/live', 'Web Live'],
  ['/docs/extension', 'Extension'],
  ['/docs/sdk', 'SDK'],
  ['/docs/protocol', 'Protocol'],
  ['/docs/troubleshooting', 'Troubleshooting']
];

type DocsKey = keyof typeof docs;

export function DocsPage({ path }: { path: string }) {
  const key = (docs[path as DocsKey] ? path : '/docs') as DocsKey;
  const page = docs[key];

  return (
    <main className="docs-layout">
      <aside className="docs-sidebar">
        <strong>Documentation</strong>
        {docLinks.map(([href, label]) => (
          <a key={href} className={href === key ? 'active' : ''} href={href}>{label}</a>
        ))}
      </aside>
      <article className="docs-content">
        <p className="eyebrow">SmartCAN Pro Docs</p>
        <h1>{page.title}</h1>
        <p className="lead">{page.intro}</p>
        {page.sections.map(([title, items]) => (
          <section key={title} className="doc-section">
            <h2>{title}</h2>
            <ul>
              {items.map((item) => <li key={item}>{item}</li>)}
            </ul>
          </section>
        ))}
      </article>
    </main>
  );
}
